import {DataObjectId, newsCompanyId} from 'yougile-model'
import {DepartmentsClient} from '@client/departments-client'
import {Sync} from '@client/sync'
import {UsersTableUtil} from '@components/common/users-table/users-table-util'
import {ChatSubscribers} from '@extensions/chat-subscribers'

export class ChatSubscribersService {
  constructor(private taskId?: DataObjectId) {}

  get task() {
    return this.box.getHub(this.taskId)
  }

  get box() {
    return Sync.getCurrentSandbox()
  }

  get isTask() {
    return !(
      this.box.companyId === newsCompanyId ||
      this.box.companyId === Sync.profileId
    )
  }

  makePublic() {
    if (this.task) {
      delete this.task.data.private
      this.task.commit()
    }
  }

  getDepartments(userId: DataObjectId) {
    const departments = DepartmentsClient.listForUser(this.box, userId)
    return departments.map(x => x.title).join(', ')
  }

  getSubscribedUsers() {
    return this.box
      .getAllUsers(false)
      .filter(u => ChatSubscribers.isSubscribed(u.id, this.task))
      .map(u => u.id)
  }

  getAllUsers() {
    const allUsers = this.box.getAllUsers(false)
    const calculatedHierarchy = DepartmentsClient.getHierarchy(this.box)
    return allUsers
      .filter(
        u =>
          ChatSubscribers.isSubscribed(u.id, this.task) ||
          ChatSubscribers.canBeSubscribed(u.id, this.task, calculatedHierarchy)
      )
      .map(u => {
        return UsersTableUtil.convertUser(this.box, u)
      })
  }
}
